module.exports = __webpack_public_path__ + "static/media/eye-transparent.c9d966d0.png";